import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { styled } from '@mui/system';
import { Container, Item } from 'Components/Grid';
import HistoryRowBasicItem from 'Components/HistoryRowBasicItem';

const StyledHistory = styled('div')({});

const fm = (id: string, values?: { [key: string]: string | number | null }): React.JSX.Element => (
  <FormattedMessage id={id} values={values} />
);

const Diet = ({ document }: IOwnProps): React.JSX.Element => {
  return (
    <StyledHistory>
      <Container>
        <Item xs={5}>
          <HistoryRowBasicItem
            header={fm('dietTherapy.diet')}
            value={document.diet ? fm(`dietTherapy.opts.${document.diet}`) : '-'}
          />
        </Item>
        <Item>
          <HistoryRowBasicItem
            header={fm('dietTherapy.reason')}
            value={
              <Item>
                {Array.isArray(document.reason)
                  ? document.reason.map((r, i) => <div key={i}>{fm(`dietTherapy.opts.${r}`)}</div>)
                  : '-'}
              </Item>
            }
          />
        </Item>
      </Container>
    </StyledHistory>
  );
};

interface IOwnProps {
  document: IDocumentWithTypeV2<'diet'>;
  startEdit: StartEdit;
  view?: IView;
}

export default Diet;
